
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import RecoverCodeForm from "@/form/recover/recoverCode/recoverCode";
import Timer from "@/UI/components/common/Timer.vue";
@Component({
  components: {FormGroup, Timer}
})
export default class RecoverCode extends Vue {
  @Prop() readonly form!: RecoverCodeForm;
  showTimer = true;
  resend(): void {
    this.$emit('submitPhone');
    this.showTimer = true;
  }
}
